import { render } from "./discounts.vue?vue&type=template&id=364c206a&scoped=true"
import script from "./discounts.vue?vue&type=script&lang=js"
export * from "./discounts.vue?vue&type=script&lang=js"

import "./discounts.vue?vue&type=style&index=0&id=364c206a&scoped=true&lang=scss"

import exportComponent from "/builds/dobro/amway-calculator-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-364c206a"]])

export default __exports__